import useExplorerStore from "../store/store";

function useIsEnglishLang() {
    const langId = useExplorerStore((store) => store.config.languageId);
    return langId === 1;
}

export default useIsEnglishLang;
